<template>
    <vue-final-modal
        @opened="opened"
        v-bind="$attrs"
        v-slot="{ close }"
        :esc-to-close="true"
    >
        <div class="opui-modal opui-modal-course-edit">
            <div class="opui-modal-dialog opui-mw-900">
                <div class="opui-modal-content">
                    <div class="opui-modal-header">
                        <h1>Log Details</h1>
                        <i @click.prevent="close" class="opui-icon-close opui-modal-close"></i>
                    </div>

                    <div class="opui-modal-body">
                        <p>Workflow: <strong>{{ row.workflow_title }}</strong></p>
                        <p>Trigger: <strong>{{ row.title }}</strong></p>
                        <p>When: <strong>{{ row.created_at }}</strong></p>
                        <p>Status: <strong>{{ row.status }}</strong></p>
                        <hr>

                        <ol v-if="row.items" class="opfl-status-items">
                            <li v-for="item in row.items">
                                {{ item.title }} @ {{ item.created_at }}<br>
                                <small>
                                    {{ item.status }}: {{ item.message }}
                                </small>
                            </li>
                        </ol>
                        <hr>

                        <textarea style="height: 250px;">{{ row }}</textarea>
                    </div>
                </div>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>
export default {
    props: {
        row: { type: Object, required: true }
    }
}
</script>

<style scoped>
.opfl-status-items {
    font-size: 14px;
}
</style>
